module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 305.1 487"><path d="M301.2 324.9c-5.3-5.3-13.8-5.3-19.1 0l-116 116V13.5c0-7.5-6-13.5-13.5-13.5s-13.5 6-13.5 13.5v427.4l-116-116c-5.3-5.3-13.8-5.3-19.1 0-5.3 5.3-5.3 13.8 0 19.1l139 139c2.5 2.5 6 4 9.5 4s7-1.4 9.5-4l139-139c5.4-5.2 5.4-13.8.2-19.1z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow_down.svg
// module id = 522
// module chunks = 1